namespace $.$$ {

	export class $shm_radio extends $.$shm_radio {

		circle_inner() {
			return this.checked() ? [ this.Circle_inner() ] : []
		}

	}

}
